/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_viewer = {
    readonly isPinterestShareEnabled?: boolean | null;
    readonly isFacebookShareEnabled?: boolean | null;
    readonly shareJewelryItemTooltip?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
    readonly " $refType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$data = PdpRespIconBubbles_viewer;
export type PdpRespIconBubbles_viewer$key = {
    readonly " $data"?: PdpRespIconBubbles_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPinterestShareEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "PINTEREST_SHARE"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
        },
        {
          "alias": "isFacebookShareEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "FACEBOOK_SHARE"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
        },
        {
          "alias": "shareJewelryItemTooltip",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "shareJewelryItemTooltip"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"shareJewelryItemTooltip\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '5c6fa180adb101197b75e16c25c20461';
export default node;
